// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__u-LV1","hover":"Cursor_hover__p5MPL","swiperHover":"Cursor_swiperHover__ZkjBU"};